import { gql } from '@apollo/client';

export default gql`
  query notificationTypes($audience: String) {
    notificationTypes(audience: $audience) {
      id
      name
      description
      symbol
    }
  }
`;
